import { render, staticRenderFns } from "./ThePlusIcon.vue?vue&type=template&id=324efa41&"
import script from "./ThePlusIcon.vue?vue&type=script&lang=js&"
export * from "./ThePlusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports